import React from "react";
import { useSelector } from "react-redux";

const LikeIcon = ({ color, className }) => {
  // PASS HEX CODE FOR COLOR WITHOUT HASHTAG(#)

  // FETCHING STATES FROM REDUCER
  const appAccentColor = useSelector(
    (state) => state?.persistedDataReducer?.appAccent
  );

  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M13.0029 8V4C13.0029 3.20435 12.6869 2.44129 12.1243 1.87868C11.5616 1.31607 10.7986 1 10.0029 1L6.00293 10V21H17.2829C17.7653 21.0055 18.2333 20.8364 18.6008 20.524C18.9684 20.2116 19.2106 19.7769 19.2829 19.3L20.6629 10.3C20.7064 10.0134 20.6871 9.72068 20.6063 9.44225C20.5254 9.16382 20.385 8.90629 20.1948 8.68751C20.0045 8.46873 19.769 8.29393 19.5045 8.17522C19.24 8.0565 18.9528 7.99672 18.6629 8H13.0029ZM6.00293 21H3.00293C2.4725 21 1.96379 20.7893 1.58872 20.4142C1.21364 20.0391 1.00293 19.5304 1.00293 19V12C1.00293 11.4696 1.21364 10.9609 1.58872 10.5858C1.96379 10.2107 2.4725 10 3.00293 10H6.00293"
        fill={`#${color?.replace("#", "") || appAccentColor}`}
      />
      <path
        d="M6.00293 21H3.00293C2.4725 21 1.96379 20.7893 1.58872 20.4142C1.21364 20.0391 1.00293 19.5304 1.00293 19V12C1.00293 11.4696 1.21364 10.9609 1.58872 10.5858C1.96379 10.2107 2.4725 10 3.00293 10H6.00293M13.0029 8V4C13.0029 3.20435 12.6869 2.44129 12.1243 1.87868C11.5616 1.31607 10.7986 1 10.0029 1L6.00293 10V21H17.2829C17.7653 21.0055 18.2333 20.8364 18.6008 20.524C18.9684 20.2116 19.2106 19.7769 19.2829 19.3L20.6629 10.3C20.7064 10.0134 20.6871 9.72068 20.6063 9.44225C20.5254 9.16382 20.385 8.90629 20.1948 8.68751C20.0045 8.46873 19.769 8.29393 19.5045 8.17522C19.24 8.0565 18.9528 7.99672 18.6629 8H13.0029Z"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default LikeIcon;
